export function alipayReady(callback) {
	let bridge = window.AlipayJSBridge
	if (typeof bridge !== 'undefined') {
		callback(null, bridge)
	} else {
    document.addEventListener('AlipayJSBridgeReady', (bridge) => {
			callback(null, bridge)
		})
	}
}
